import createImageUrlBuilder from "@sanity/image-url";

const imageBuilder = createImageUrlBuilder({
  projectId: "jqwndp5n",
  dataset: "production",
});

export const urlForImage = (source) => {
  return imageBuilder?.image(source).auto("format").fit("max");
};
